/**
 * Helper function to determine if button text should be white
 * or black, based upon the value of "custom_cmp_color" from the model
 * Adapted from https://gomakethings.com/dynamically-changing-the-text-color-based-on-background-color-contrast-with-vanilla-js/
 */

/* eslint-disable no-magic-numbers */
const colorHelper = (hexcolor: string) => {
  let color: string
  // remove the leading '#' character
  color = hexcolor.slice(1)
  // handle hexcode color shorthand (e.g., #eee)
  color = color.length > 3 ? color : color + color
  const r = parseInt(color.substr(0, 2), 16)
  const g = parseInt(color.substr(2, 2), 16)
  const b = parseInt(color.substr(4, 2), 16)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 128 ? '#000000' : '#FFFFFF'
}
/* eslint-enable no-magic-numbers */

export default colorHelper
